// @ts-nocheck

import v4 from 'uuid/v4';

import { getWapiDynamicEndpoint } from '../config/urls';

import fetch from './fetch';

export const makeWapiCall = async (options) => {
  try {
    const { namespace: ns, method, params } = options;
    const endpoint = `${getWapiDynamicEndpoint()}/${ns}`;
    const body = {
      ns,
      method,
      params,
      id: v4(),
      ts: Date.now(),
    };
    const response = await fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    return response.json();
  } catch (e) {
    return null;
  }
};
